import { render, staticRenderFns } from "./ImpresoraFaq.vue?vue&type=template&id=0feddbe3&scoped=true"
import script from "./ImpresoraFaq.vue?vue&type=script&lang=js"
export * from "./ImpresoraFaq.vue?vue&type=script&lang=js"
import style0 from "./ImpresoraFaq.vue?vue&type=style&index=0&id=0feddbe3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0feddbe3",
  null
  
)

export default component.exports